import script from "./PersonalInfoStep2Content.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep2Content.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep2Content.vue?vue&type=style&index=0&id=67a06f46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a06f46"]])

export default __exports__